import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';
import { FlexRow, Gap } from 'ui-components/components/flex';
import { NumberInput } from 'ui-components/components/number-input';

import { messages } from './received-products.messages';
import styles from './numeric-input-row.styles.module.less';
import { ReceivedProductsColumns } from './received-products-columns-constants';

type CellProps = {
  value: number;
};

type RowOriginal = {
  orderedQuantity: number;
  receivedQuantity: number | null;
  rejectedQuantity: number | null;
};

type RowProps = {
  index: number;
  original: RowOriginal;
};

type ColumnProps = {
  id: string;
};

type NumericColumnCellProps = {
  cell: CellProps;
  row: RowProps;
  column: ColumnProps;
  updateData: (rowIndex: number, columnId: string, value: number) => void;
  showAllButton?: boolean;
};

export const NumericColumnCell = ({ cell, row, column, updateData, showAllButton = true }: NumericColumnCellProps) => {
  const { orderedQuantity, receivedQuantity, rejectedQuantity } = row.original;

  const handleChooseAll = () => {
    const otherColumnId = column.id === ReceivedProductsColumns.ACCEPT ? ReceivedProductsColumns.REJECT : ReceivedProductsColumns.ACCEPT;

    const remaining = Math.max(orderedQuantity - ((receivedQuantity ?? 0) + (rejectedQuantity ?? 0)), 0);

    updateData(row.index, column.id, remaining);
    updateData(row.index, otherColumnId, 0);
  };

  return (
    <FlexRow className={styles['row-styled']} gap={Gap.Space8}>
      <NumberInput
        className={styles['input-styled']}
        defaultValue={0}
        min={0}
        onChange={(val) => updateData(row.index, column.id, val || 0)}
        value={cell.value || 0}
      />
      {showAllButton && (
        <Button className={styles['all-button']} onClick={handleChooseAll} theme={THEME_CONSTANTS.tertiary}>
          <FormattedMessage {...messages.all} />
        </Button>
      )}
    </FlexRow>
  );
};
